import React, {useMemo, useState} from 'react';
import {useIntl} from 'react-intl';
import {useTable} from 'react-table';
import useInfiniteScrollControl
  from '../../../_common/components/_custom-hooks/useInfiniteScrollControl';
import * as actions from '../../actions/CustomerDetailsActions';
import * as columnFormatters from '../../../_common/column-formatters';
import {useCustomerDetailsUIContext} from '../CustomerDetailsUIContext';
import CommonGrid from "../../../_common/components/CommonGrid";
import styles from './styles.module.scss';
import CommonGridSpinner from '../../../_common/components/CommonGridSpinner';

const TabInspectionsByCustomer = () => {
  const {customerID} = useCustomerDetailsUIContext();
  const {formatMessage} = useIntl();
  const prefix = 'customers-inspections-column';
  const [tableRows, setTableRows] = useState([]);
  const columns = useMemo(() => [
    {
      accessor: 'firmShumaID',
      Header: formatMessage({id: `${prefix}-firmShumaID`, defaultMessage: '#'})
    },
    {
      accessor: 'fullName',
      Header: formatMessage({id: `${prefix}-fullName`, defaultMessage: 'Full name'})
    },
    {
      accessor: 'address',
      Header: formatMessage({id: `${prefix}-address`, defaultMessage: 'Address'})
    },
    {
      accessor: 'gushAndHelka',
      Header: formatMessage({id: `${prefix}-gushAndHelka`, defaultMessage: 'Gush and helka'})
    },
    {
      accessor: 'officialDate',
      Header: formatMessage({id: `${prefix}-officialDate`, defaultMessage: 'Official date'})
    },
    {
      accessor: 'estimatePriceFinal',
      Header: formatMessage({id: `${prefix}-estimate-price`, defaultMessage: 'Estimate price'})
    },
    {
      accessor: 'shumaStatusTypeName',
      Header: formatMessage({
        id: `${prefix}-shumaStatusTypeName`, defaultMessage: 'Shuma status'
      })
    },
    {
      accessor: 'originTypeName',
      Header: formatMessage({
        id: `${prefix}-originTypeName`, defaultMessage: 'Origin type'
      })
    },
    {
      accessor: 'shumaReasonName',
      Header: formatMessage({id: `${prefix}-shumaReasonName`, defaultMessage: 'Reason'})
    },
    {
      accessor: 'shumaTypeName',
      Header: formatMessage({id: `${prefix}-shumaTypeName`, defaultMessage: 'Shuma type'})
    },
  ], []);
  const data = useMemo(() => [
    ...tableRows.map((item) => {
      return {
        firmShumaID: columnFormatters.BoldColumnFormatter(item.firmShumaID, 'xl'),
        fullName: columnFormatters.BoldColumnFormatter(item.fullName),
        address: columnFormatters.BoldColumnFormatter(item.address),
        gushAndHelka: columnFormatters.BoldColumnFormatter(item.gushAndHelka),
        officialDate: columnFormatters.DateColumnFormatter(item.officialDate),
        estimatePriceFinal: columnFormatters.BoldColumnFormatter(item.estimatePriceFinal ? item.estimatePriceFinal.toLocaleString() : ''),
        shumaStatusTypeName: columnFormatters.BoldColumnFormatter(item.shumaStatusTypeName),
        originTypeName: columnFormatters.BoldColumnFormatter(item.originTypeName),
        shumaReasonName: columnFormatters.BoldColumnFormatter(item.shumaReasonName),
        shumaTypeName: columnFormatters.BoldColumnFormatter(item.shumaTypeName),
      };
    })
  ], [tableRows]);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
  });

  const infiniteScrollProps = useInfiniteScrollControl({
    currentStateStoreId: 'customerDetailsReducer',
    UIContext: useCustomerDetailsUIContext(),
    getNewEntities: actions.getInspections(customerID),
    getNextEntities: actions.getNextInspections(customerID),
    onEntitiesChange: entities => {
      entities
        ? setTableRows(entities)
        : setTableRows([])
    },
    startRequestedPageNumber: 0,
    dataLength: tableRows.length,
    scrollableTarget: 'scrollContainer',
    scrollThreshold: 0.9,
    loader: (<CommonGridSpinner/>),
    style: {
      overflow: 'inherit'
    },
  });

  const gridProps = {
    infiniteScrollProps,
    getTableProps,
    headerGroups,
    getTableBodyProps,
    prepareRow,
    rows
  }

  return (
    <CommonGrid {...gridProps} customScrollContainerStyles={styles.scrollContainer}/>
  );
};

export default TabInspectionsByCustomer;